const ACTIVITY_PANEL_WIDTH = 420;
// On a phone Activity leaves a strip of the builder showing, to tap out on.
const ACTIVITY_PANEL_MOBILE_MAX_WIDTH = 'max-md:max-w-[min(340px,calc(100%-48px))]';

export { ACTIVITY_PANEL_MOBILE_MAX_WIDTH, ACTIVITY_PANEL_WIDTH };
